import React from 'react';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';
import MeetingLocalVideo from './MeetingLocalVideo';
import { HEADER_HEIGHT, FOOTER_HEIGHT } from 'flow/utils/meeting-constants';
import { useAppSelector } from 'flow/hooks/useRedux';

import { selectRightPanelActive } from 'flow/selectors/meeting-selectors';

interface SenderAloneViewProps {
    isMinimizedView: boolean;
    isFullscreenOrNarrow: boolean;
    shouldShowSenderInGrid: boolean;
}

const SenderAloneView: React.FC<SenderAloneViewProps> = ({
    isMinimizedView,
    isFullscreenOrNarrow,
    shouldShowSenderInGrid,
}) => {
    const { i18next } = useAppContext();

    const sideBarScrollBehaviour = { overflowY: 'auto' as const };

    const rightPanelActive = useAppSelector(selectRightPanelActive);

    const getContainerClass = () => {
        if (isMinimizedView) {
            return 'flex start-0 w-full justify-center';
        } else if (isFullscreenOrNarrow) {
            return 'flex justify-center items-center flex-wrap';
        } else {
            return 'flex bg-black text-white flex-col absolute top-1.5 start-1.5 sideBarContainer [&::-webkit-scrollbar]:hidden';
        }
    };

    const getGridStyle = (): React.CSSProperties => {
        if (isFullscreenOrNarrow || isMinimizedView) {
            return {
                width: 'inherit',
                height: 'inherit',
            };
        } else {
            return {
                ...sideBarScrollBehaviour,
                height: `calc(100% - ${HEADER_HEIGHT + FOOTER_HEIGHT}px)`,
                content: 'test',
                width: 360,
            };
        }
    };

    return (
        <div className={twMerge(getContainerClass())} style={getGridStyle()}>
            {isMinimizedView || !shouldShowSenderInGrid ? (
                <div
                    className={twMerge(
                        'sender-alone flex items-center justify-center bg-black text-white',
                        !isFullscreenOrNarrow ? 'top-0 h-full' : 'top-1/2',
                        rightPanelActive && 'hidden',
                    )}
                >
                    <div>
                        {i18next.t(
                            'videoconference.video_grid.no_other_participants',
                        )}
                    </div>
                </div>
            ) : null}
            {!isMinimizedView && <MeetingLocalVideo />}
        </div>
    );
};

export default SenderAloneView;
